export const ONE_YEAR = 31536000; // in seconds

export const CHANNELS_COLLECTION_FETCH_STALE_TIME = 3600000; // 1 hour
